import(/* webpackMode: "eager", webpackExports: ["SearchFilters"] */ "/vercel/path0/app/[locale]/products/ProductsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/vercel/path0/components/cart/CartProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/DynamicPrice.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/products/ProductImage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/products/QuickAddButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ScrollAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
